import { useCallback, useEffect, useLayoutEffect } from "react";
import ServerSideService from "../utilities/serverSideService";
import DivSafeZone from "./divSafeZone/divSafeZone";

export interface IHeaderSafeZoneProps {
  setHeaderSafeZone: (element: HTMLElement) => void;
}

export const HeaderSafeZone = (props: IHeaderSafeZoneProps) => {
  const isServerSide = ServerSideService.isServerSide;

  const windowResized = useCallback(() => {
    if (isServerSide) {
      return;
    }
    props.setHeaderSafeZone(
      document.getElementById("header-top") as HTMLElement
    );
    // need props.setHeaderSafeZone dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.setHeaderSafeZone]);

  (isServerSide ? useEffect : useLayoutEffect)(() => {
    if (isServerSide) {
      return;
    }
    props.setHeaderSafeZone(
      document.getElementById("header-top") as HTMLElement
    );
  });

  useEffect(() => {
    if (isServerSide) {
      return;
    }
    window.addEventListener("resize", windowResized);

    return () => {
      window.removeEventListener("resize", windowResized);
    };
  }, [isServerSide, windowResized]);

  return <DivSafeZone id="header-top" className="dsz-standard" />;
};
